
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/windows/gealan",
      function () {
        return require("private-next-pages/pvc/windows/gealan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/windows/gealan"])
      });
    }
  